import React, { useMemo } from 'react';
import {
  GeckoCardTable,
  GeckoIcon,
  TooltipIdStr,
  Tooltip,
  OverlayTrigger,
} from 'ui';

const EllucianIntegration = () => {

  const openHelpLink = (link) => () => window.open(link);
  const renderHelpIcon = () => <i
    className="fas fa-question-circle Integration-info-button"
  />

  const contactFields = [
    {
      "primaryAttribute": {
        "id": "first_name",
        "type": "text",
        "module": "contact",
        "label": "First Name",
        "config": {
          "label": "First Name"
        }
      },
      "secondaryAttribute": {
        "id": "names",
        "type": "name",
        "module": "Persons",
        "label": "First name (personal)",
        "config": {
          "format": "firstName"
        }
      },
      "usedForMatchingConditions": 'Yes'
    },
    {
      "primaryAttribute": {
        "id": "last_name",
        "type": "text",
        "module": "contact",
        "label": "Last Name",
        "config": {
          "label": "Last Name"
        }
      },
      "secondaryAttribute": {
        "id": "names",
        "type": "name",
        "module": "Persons",
        "label": "Last name (personal)",
        "config": {
          "format": "lastName"
        }
      },
      "usedForMatchingConditions": 'Yes'
    },
    {
      "primaryAttribute": {
        "id": "email",
        "type": "email",
        "module": "contact",
        "label": "Email",
        "config": {
          "label": "Email"
        }
      },
      "secondaryAttribute": {
        "id": "emails",
        "type": "email",
        "module": "Persons",
        "label": "Email address (personal)",
        "config": {
          "format": "address"
        }
      },
      "usedForMatchingConditions": 'Yes'
    },
    {
      "primaryAttribute": {
        "id": "tel",
        "type": "telephone",
        "module": "contact",
        "label": "Telephone",
        "config": {
          "label": "Telephone"
        }
      },
      "secondaryAttribute": {
        "id": "phones",
        "type": "phone",
        "module": "Persons",
        "label": "Phone number (mobile)",
        "config": {
          "format": "number"
        }
      },
      "usedForMatchingConditions": 'No'
    }
  ];

  const columns = useMemo(() => {
    const integrationModuleColumn = {
      key: 'secondaryAttribute.module',
      name: `Banner module`,
      sortable: true,
    };
    const integrationLabelColumn = {
      key: 'secondaryAttribute.label',
      name: `Banner field`,
      sortable: true,
    };
    const chatLabelColumn = {
      key: 'primaryAttribute.label',
      name: `GeckoChat field`,
      sortable: true,
    };
    const matchingConditionsColumn = {
      key: 'usedForMatchingConditions',
      name: 'Used for matching conditions',
      width: '10%',
      sortable: true,
    };

    return {
      contact: [
        { ...integrationModuleColumn, width: '30%' },
        { ...integrationLabelColumn, width: '30%' },
        { ...chatLabelColumn, width: '30%' },
        { ...matchingConditionsColumn, width: '10%' },
      ],
    };
  }, [
  ]);

  return (
    <div className="content-margin Integrations">
      <GeckoCardTable
        name={<span>
          Contact fields&nbsp;
          <OverlayTrigger
            placement="right"
            overlay={
              <Tooltip id={TooltipIdStr('BannerInfo')}>
                Field mappings are not editable at this time
              </Tooltip>
            }
          ><span id={TooltipIdStr('BannerInfo')}>
            <GeckoIcon icon="fas fa-exclamation-circle" />
          </span>
          </OverlayTrigger>
        </span>}
        cols={columns.contact}
        rows={contactFields}
        alert="You have not mapped any contact fields yet."
      />
    </div>
  );
};

export default EllucianIntegration;
